<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <md-field v-if="!this.valid" :class="messageClass" class="label-top">
      <span class="md-error">*Required.</span>
    </md-field>
    <div class="quiz-iframe-wrapper">
      <iframe v-show="saveData.value && saveData.value.id && ready"
        @load="iframeLoad"
        :id="'quiz-iframe-' + saveData.value.id"
        class="quiz-iframe"
        :class="{'hidden': !(this.step == this.active) }"
        :data-content-id="saveData.value.id"
        frameborder="0"
        scrolling="no"
        :src="iframeUrl"
        ref="iframe"
        :title="saveData.label != '' ? saveData.label : saveData.node_name"
      ></iframe>
      <spinner v-if="showLoader"></spinner>
    </div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Quiz'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <h2>Quiz: {{saveData.value.name | token_replace(nid, 'quiz')}}</h2>
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-autocomplete
          :value="tempData.node_name"
          md-value-key="value"
          :md-options="node_list"
          @md-changed="getNodes"
          @md-opened="getNodes"
          @md-selected="setQuiz"
        >
          <label>Quiz Content</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
        </md-autocomplete>
        <md-checkbox v-model="tempData.required">Required</md-checkbox><br/>
        <md-checkbox v-model="tempData.include_submission">Include on submission view and download</md-checkbox>
        <p><a target="_blank" href="/quiz/add/quiz">Create Quiz</a></p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import Spinner from "../../Spinner.vue";
import HelpersMixin from '../../../HelpersMixin';

export default {
  name: "FbQuiz",
  props: ["element", "mode", "validate", "step", "active"],
  mixins: [FbElementMixin, HelpersMixin],
  components: {
    Spinner
  },
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.result =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      if (
        (this.saveData.required === false && this.step == this.active) ||
        (this.saveData.required === false && this.viewed)
      ) {
        return true;
      }
      if (this.saveData.required === false) {
        return true;
      }

      return (
        this.saveData.required === true &&
        this.saveData.result.completion === true
      );
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.saveData.result,
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  mounted: function() {
    //this.init();
    this.$emit('quiz-init', this)
  },
  activated: function() {
    this.init();
  },
  data() {
    return {
      node_list_ext: [],
      node_list: [],
      result_list: [],
      iframeUrl: null,
      ready: false,
      viewed: false,
      vid: null,
      pass_rate: null,
      showLoader: false,
      tempData: {
        node_name:
          this.element && this.element.data ? this.element.data.node_name : "",
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : {},
        result: {},
        required:
          this.element && this.element.data
            ? !!this.element.data.required
            : false,
        include_submission:
          this.element && this.element.data
            ? !!this.element.data.include_submission
            : false
      },
      saveData: {
        node_name:
          this.element && this.element.data ? this.element.data.node_name : "",
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : {},
        result: {},
        required:
          this.element && this.element.data
            ? !!this.element.data.required
            : false,
        include_submission:
          this.element && this.element.data
            ? !!this.element.data.include_submission
            : false
      }
    };
  },
  methods: {
    init() {
      return this.getQuiz().then((res) => {
        let iframe_url = '/quiz/' + this.saveData.value.id;
        let quiz = res.data[0];
        this.vid = quiz.attributes.drupal_internal__vid;
        this.pass_rate = quiz.attributes.pass_rate;
        this.getQuizResults().then(() => {
          if (res.data && res.data.length) {
            if (this.result_list) {
              let finished_results = this.result_list.filter((result)=>{
                return result.is_evaluated;
              });

              if (finished_results.length == 0) {
                // quiz.attributes.takes && quiz.attributes.takes == 1 ||
                // redurect to /take.
                iframe_url += '/take';
              }
            }
          }

          this.ready = true;
          this.showLoader = true;
          if (this.step == this.active) {
            this.viewed = true;
            this.$emit("validation", this.valid);
            this.$emit("set-value", this.value);
          }
          this.iframeUrl = iframe_url
        }).catch(()=>{
          this.iframeUrl = iframe_url;
        });
      });
    },
    updateQuizResults() {
      setTimeout(() => {
        this.getQuizResults().then(() => {
          this.saveData.result = {
            completion: false,
            vid: this.vid,
            score: 0,
          };
          let last_score = 0;
          this.result_list.forEach((res) => {
            if (res.is_evaluated && this.pass_rate && this.pass_rate > 0 && res.score >= this.pass_rate) {
              if (last_score < res.score) {
                this.saveData.result = {
                  completion: true,
                  vid: this.vid,
                  score: res.score
                };
              }
            }
            else if (res.is_evaluated && !this.pass_rate) {
              this.saveData.result = {
                completion: true,
                vid: this.vid,
                score: res.score
              };
            }
          });
          this.$emit("validation", this.valid);
          this.$emit("set-value", this.value);
        });
      }, 300)
    },
    getQuiz() {
      let quizId = this.saveData.value.id;
      let quizUrl = '/jsonapi/quiz/quiz?filter[qid]=' + quizId;
      return fetch(quizUrl)
        .then(res => {
          return res.json();
        })
        .then(json => {
          return json;
        });
    },
    getQuizResults() {
      if (!this.vid) {
        return new Promise((resolve)=>{
          resolve(false);
        });
      }
      let uid = drupalSettings.user.uid;
      let resultsUrl = '/jsonapi/quiz_result/quiz_result?filter[is_invalid]=0&filter[uid.meta.drupal_internal__target_id]=' + uid + '&filter[vid]=' + this.vid + '&include=uid'
      return fetch(resultsUrl)
        .then(res => {
          return res.json();
        })
        .then(json => {
          let res = json.data.map(el => {
            return {
              id:  el.attributes.drupal_internal__result_id,
              quiz_result_type: el.attributes.quiz_result_type,
              vid:  el.attributes.vid,
              time_start: el.attributes.time_start,
              time_end: el.attributes.time_end,
              released: el.attributes.released,
              score: el.attributes.score,
              is_invalid: el.attributes.is_invalid,
              is_evaluated: el.attributes.is_evaluated,
              attempt: el.attributes.attempt,
              created: el.attributes.created,
              changed: el.attributes.changed
            };
          });

          this.result_list = res;
        });
    },
    getNodes(searchTitle) {
      this.node_list = new Promise(resolve => {
        if (!searchTitle) {
          resolve(this.node_list_ext);
          return;
        }
        const node = searchTitle.toLowerCase();
        const content_manager_groups = drupalSettings.user.content_manager_groups;

        let requestUri = "/jsonapi/quiz/quiz?filter[title][condition][path]=title&filter[title][condition][value]=" +
          node +
          "&filter[title][condition][operator]=CONTAINS&filter[status]=1";
        if (this.isAdministrator() != true) {
          if (content_manager_groups && Object.keys(content_manager_groups).length) {
            requestUri += '&filter[field_group_user][group][conjunction]=OR';
            requestUri += '&filter[field_group][condition][path]=field_group.id&';
            Object.keys(content_manager_groups).forEach((value, index) => {
              requestUri += '&filter[field_group][condition][value][' +index +']=' + value;
            });
            requestUri += '&filter[field_group][condition][operator]=IN';
            requestUri += '&filter[field_group][condition][memberOf]=field_group_user';
            requestUri += "&filter[uid][condition][path]=uid.id";
            requestUri += "&filter[uid][condition][value]=" + window.drupalSettings.user.uuid;
            requestUri += "&filter[uid][condition][memberOf]=field_group_user";
          }
          else {
            requestUri += "&filter[uid.id][value]=" + window.drupalSettings.user.uuid;
          }
        }

        fetch(requestUri)
          .then(res => {
            return res.json();
          })
          .then(json => {
            let res = json.data.map(el => {
              return {
                id: el.attributes.drupal_internal__qid,
                name: el.attributes.title
              };
            });
            let filtered = res.filter(({ name }) => {
              return name.toLowerCase().includes(node);
            });
            this.node_list_ext = filtered;
            resolve(filtered);
          })
          .catch(() => {
            resolve(this.node_list_ext);
          });
      });
    },
    setQuiz(event) {
      this.tempData.node_name = event.name;
      this.tempData.value = event;
    },
    updateQuiz(quiz) {
      this.saveData.value = quiz;
      this.$emit("validation", this.valid);
    },
    iframeLoad() {
      this.initIframeEvents();
      this.updateQuizResults();
    },
    initIframeEvents() {
      let iframe = this.$refs.iframe;
      let iframeDoc = iframe.contentDocument;
      let iframeWindow = iframe.contentWindow;
      let resizer = function () {
        let contentArea = iframeDoc.getElementsByClassName('dialog-off-canvas-main-canvas').item(0);
        if (!contentArea) {
          return;
        }
        let height = contentArea.offsetHeight + 40;
        iframe.style.height = height + 'px';
      }
      // let href = window.location.href;
      // href = href.replace(/(\?|\&)back_hash=.+?($|\&)/, "$2");
      // href = href.replace(/(\?|\&)iframe_src=.+?($|\&)/, "$2");
      // let frameLocation = iframe.contentWindow.location.pathname;
      // href += (isWithGet ? '&' : '?') + 'back_hash=' + this.element.uuid + '&iframe_src=' + frameLocation;
      // history.replaceState( {} , null, href);
      iframeWindow.addEventListener('resize', function() {
        resizer();
      });
      // Show loader on iframe reload.
      iframeWindow.addEventListener('beforeunload', (event) => {
        this.showLoader = true;
      });
      resizer();
      let sumbitForm = iframeDoc.querySelector('.answering-form');
      if(sumbitForm) {
        // Show loader on form submit.
        sumbitForm.addEventListener('submit', (event) => {
          this.showLoader = true;
        });
      }

      this.showLoader = false;
    },
    async initIframe() {
      return new Promise((resolve, reject) => {
        this.init().then(()=> {
          setTimeout(() => {
            resolve();
          }, 1000)
        });
      })
    },
  },
  watch: {
    watch: {
      active(val) {
        if (this.viewed === false && val == this.step) {
          this.viewed = true;
        }
        this.$emit("validation", this.valid);
      },
      valid(val) {
        if (val == true) {
          this.$emit("set-value", this.value);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.quiz-iframe-wrapper {
  position: relative;
  .spinner-wrapper {
    background-color: rgba(0,0,0,0);
    position: absolute !important;
  }
}
.quiz-iframe-wrapper .quiz-iframe {
  width: 100%;
}
</style>
